// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperAbstract-cls1___d5de8372f069f746e5d{/*!*/}.PaperAbstract-cls2__b5108e9a4fc6339f472a{margin-top:var(--spacing-xs-16);margin-bottom:-16px;aspect-ratio:3/2;overflow:hidden;cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperAbstract-cls1___d5de8372f069f746e5d",
	"cls2": "PaperAbstract-cls2__b5108e9a4fc6339f472a PaperAbstract-cls1___d5de8372f069f746e5d"
};
export default ___CSS_LOADER_EXPORT___;
